/* IM Digital Agency — Email Marketing Landing (vanilla JS, zero dipendenze) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE_OUT = 'cubic-bezier(0, 0, 0.58, 1)';

  function setTransition(el, duration, delay) {
    el.style.transition = 'opacity ' + duration + 's ' + EASE_OUT + ' ' + delay + 's, transform ' + duration + 's ' + EASE_OUT + ' ' + delay + 's';
  }

  /* ---------- Entrata hero (al caricamento) ---------- */
  function initEnter(root) {
    var els = root.querySelectorAll('[data-enter]');
    els.forEach(function (el) {
      setTransition(el, parseFloat(el.dataset.duration || '0.6'), parseFloat(el.dataset.delay || '0'));
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        els.forEach(function (el) { el.classList.add('is-in'); });
      });
    });
  }

  /* ---------- Reveal on scroll (Framer whileInView, once, margin -80px) ---------- */
  function initReveal(root) {
    var els = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    els.forEach(function (el) { setTransition(el, 0.6, parseFloat(el.dataset.delay || '0')); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '-80px 0px -80px 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header sticky (scrollY > 80) ---------- */
  function initSticky(root) {
    var header = root.querySelector('[data-iml-sticky]');
    if (!header) return;
    var links = header.querySelectorAll('a');
    var visible = false;
    function update() {
      var show = window.scrollY > 80;
      if (show === visible) return;
      visible = show;
      header.classList.toggle('is-visible', show);
      header.setAttribute('aria-hidden', show ? 'false' : 'true');
      links.forEach(function (a) { show ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Header con menu ---------- */
  function initNav(root) {
    var nav = root.querySelector('[data-iml-nav]');
    if (!nav) return;
    // Il menu resta nel flusso sotto la fascia dei bandi; quando la supera diventa fisso.
    var holder = root.querySelector('[data-iml-nav-holder]');
    function syncHeight() { if (holder) holder.style.minHeight = nav.offsetHeight + 'px'; }
    function onScroll() {
      var fixed = holder ? holder.getBoundingClientRect().top <= 0 : window.scrollY > 10;
      nav.classList.toggle('is-fixed', fixed);
      nav.classList.toggle('is-scrolled', fixed);
    }
    syncHeight();
    window.addEventListener('resize', syncHeight);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var subs = Array.prototype.slice.call(nav.querySelectorAll('[data-iml-sub]'));
    function closeAll(except) {
      subs.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = li.querySelector('button'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    subs.forEach(function (li) {
      var btn = li.querySelector('button');
      var hoverTimer;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !li.classList.contains('is-open');
        closeAll(li);
        li.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      if (window.matchMedia('(hover: hover)').matches) {
        li.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); closeAll(li); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); });
        li.addEventListener('mouseleave', function () { hoverTimer = setTimeout(function () { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); });
      }
    });
    document.addEventListener('click', function () { closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });

    var burger = nav.querySelector('[data-iml-burger]');
    var drawer = nav.querySelector('[data-iml-drawer]');
    function closeDrawer() {
      if (!burger || !drawer) return;
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Apri menu');
      drawer.hidden = true;
      nav.classList.remove('is-open');
    }
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') !== 'true';
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Chiudi menu' : 'Apri menu');
        drawer.hidden = !open;
        nav.classList.toggle('is-open', open);
      });
      drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
    }
  }

  /* ---------- Parole che ruotano nei titoli ---------- */
  function initRotate(root) {
    root.querySelectorAll('[data-iml-rotate]').forEach(function (el) {
      var words = el.querySelectorAll('.iml-rot__w');
      if (words.length < 2 || reduceMotion) return;
      var i = 0;
      setInterval(function () {
        words[i].classList.remove('is-active'); words[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % words.length;
        words[i].classList.add('is-active'); words[i].removeAttribute('aria-hidden');
      }, 2400);
    });
  }

  /* ---------- Accordion FAQ (single, collapsible) ---------- */
  function initAccordion(root) {
    var acc = root.querySelector('[data-iml-accordion]');
    if (!acc) return;
    var items = Array.prototype.slice.call(acc.querySelectorAll('[data-item]'));

    function close(item) {
      var btn = item.querySelector('.iml-faq__trigger');
      var panel = item.querySelector('.iml-faq__panel');
      if (!item.classList.contains('is-open')) return;
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      panel.style.height = panel.scrollHeight + 'px';
      panel.offsetHeight; // reflow
      panel.style.height = '0px';
      var done = function () { panel.hidden = true; panel.style.height = ''; panel.removeEventListener('transitionend', done); };
      reduceMotion ? done() : panel.addEventListener('transitionend', done);
    }

    function open(item) {
      var btn = item.querySelector('.iml-faq__trigger');
      var panel = item.querySelector('.iml-faq__panel');
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = '0px';
      panel.offsetHeight;
      panel.style.height = panel.scrollHeight + 'px';
      var done = function () { panel.style.height = ''; panel.removeEventListener('transitionend', done); };
      reduceMotion ? done() : panel.addEventListener('transitionend', done);
    }

    items.forEach(function (item) {
      item.querySelector('.iml-faq__trigger').addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(close);
        if (!isOpen) open(item);
      });
    });
  }

  /* ---------- Carousel video ---------- */
  function initCarousel(root) {
    var car = root.querySelector('[data-iml-carousel]');
    if (!car) return;
    var slides = car.querySelectorAll('[data-slide]');
    var dots = car.querySelectorAll('[data-dot]');
    var current = 0;
    var busy = false;

    function go(index) {
      if (index === current || busy) return;
      busy = true;
      var prev = slides[current];
      var pv = prev.querySelector('video');
      if (pv) pv.pause();
      prev.classList.add('is-leaving');
      prev.classList.remove('is-active');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      // AnimatePresence mode="wait": prima esce, poi entra
      setTimeout(function () {
        prev.classList.remove('is-leaving');
        slides[index].classList.add('is-active');
        current = index;
        busy = false;
      }, reduceMotion ? 0 : 300);
    }

    var prevBtn = car.querySelector('[data-prev]');
    var nextBtn = car.querySelector('[data-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(current === 0 ? slides.length - 1 : current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current === slides.length - 1 ? 0 : current + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); }); });
  }

  /* ---------- Grafici hero (replica Recharts) ---------- */
  var DEFAULT_DATA = [
    { month: 'Gen', revenue: 12000, emails: 4200 },
    { month: 'Feb', revenue: 15500, emails: 5800 },
    { month: 'Mar', revenue: 18200, emails: 7100 },
    { month: 'Apr', revenue: 22800, emails: 8900 },
    { month: 'Mag', revenue: 28500, emails: 11200 },
    { month: 'Giu', revenue: 35000, emails: 13800 },
    { month: 'Lug', revenue: 42000, emails: 16500 },
    { month: 'Ago', revenue: 51000, emails: 19200 }
  ];
  var NS = 'http://www.w3.org/2000/svg';
  var C_PRIMARY = '#00ccd9';
  var C_TICK = '#8597a5';
  var C_GRID = 'rgba(255,255,255,0.08)';

  function svgEl(tag, attrs) {
    var el = document.createElementNS(NS, tag);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }

  // scala "nice" come Recharts (tickCount 5)
  function niceMax(max) {
    var raw = max / 4;
    var mag = Math.pow(10, Math.floor(Math.log10(raw)));
    var steps = [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];
    for (var i = 0; i < steps.length; i++) {
      if (steps[i] * mag >= raw) return { step: steps[i] * mag, max: steps[i] * mag * 4 };
    }
    return { step: 10 * mag, max: 40 * mag };
  }

  // d3 curveMonotoneX
  function monotonePath(pts) {
    var n = pts.length;
    if (n < 2) return '';
    var t = new Array(n);
    var s = [];
    for (var i = 0; i < n - 1; i++) s.push((pts[i + 1][1] - pts[i][1]) / (pts[i + 1][0] - pts[i][0]));
    function sign(x) { return x < 0 ? -1 : 1; }
    for (i = 1; i < n - 1; i++) {
      var h0 = pts[i][0] - pts[i - 1][0], h1 = pts[i + 1][0] - pts[i][0];
      var s0 = s[i - 1], s1 = s[i];
      var p = (s0 * h1 + s1 * h0) / (h0 + h1);
      t[i] = (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
    }
    var hA = pts[1][0] - pts[0][0];
    t[0] = hA ? (3 * s[0] - t[1]) / 2 : t[1];
    var hB = pts[n - 1][0] - pts[n - 2][0];
    t[n - 1] = hB ? (3 * s[n - 2] - t[n - 2]) / 2 : t[n - 2];
    var d = 'M' + pts[0][0] + ',' + pts[0][1];
    for (i = 0; i < n - 1; i++) {
      var dx = (pts[i + 1][0] - pts[i][0]) / 3;
      d += 'C' + (pts[i][0] + dx) + ',' + (pts[i][1] + dx * t[i]) + ',' +
        (pts[i + 1][0] - dx) + ',' + (pts[i + 1][1] - dx * t[i + 1]) + ',' +
        pts[i + 1][0] + ',' + pts[i + 1][1];
    }
    return d;
  }

  // Legge mesi/valori dagli attributi data-* impostati nel customizer
  function readData(el) {
    var split = function (v) { return (v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); };
    var labels = split(el.dataset.labels);
    var rev = split(el.dataset.revenue).map(Number);
    var em = split(el.dataset.emails).map(Number);
    var n = Math.min(labels.length, rev.length);
    if (!n || rev.some(isNaN)) return DEFAULT_DATA;
    var out = [];
    for (var i = 0; i < n; i++) out.push({ month: labels[i], revenue: rev[i], emails: isNaN(em[i]) ? 0 : em[i] });
    return out;
  }

  var DATA = DEFAULT_DATA;
  var CURRENCY = '€';
  var TIP_LABEL = 'Revenue';

  function fmtK(v) { return CURRENCY + (v / 1000).toFixed(0) + 'k'; }

  function drawArea(box) {
    box.innerHTML = '';
    var W = box.clientWidth, H = box.clientHeight;
    if (!W || !H) return;
    // margin {top:5,right:5,left:-20,bottom:0} + YAxis 60 + XAxis 30
    var x0 = -20 + 60, x1 = W - 5, y0 = 5, y1 = H - 30;
    var scale = niceMax(Math.max.apply(null, DATA.map(function (d) { return d.revenue; })));
    var xs = function (i) { return x0 + i * (x1 - x0) / (DATA.length - 1); };
    var ys = function (v) { return y1 - (v / scale.max) * (y1 - y0); };
    var uid = 'imlg' + Math.random().toString(36).slice(2, 8);

    var svg = svgEl('svg', { width: W, height: H, viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': 'Revenue da email ultimi 8 mesi' });
    svg.style.display = 'block';
    var defs = svgEl('defs', {});
    var grad = svgEl('linearGradient', { id: uid, x1: 0, y1: 0, x2: 0, y2: 1 });
    grad.appendChild(svgEl('stop', { offset: '0%', 'stop-color': C_PRIMARY, 'stop-opacity': 0.4 }));
    grad.appendChild(svgEl('stop', { offset: '100%', 'stop-color': C_PRIMARY, 'stop-opacity': 0 }));
    defs.appendChild(grad);
    var clip = svgEl('clipPath', { id: uid + 'c' });
    var clipRect = svgEl('rect', { x: x0, y: 0, width: reduceMotion ? (x1 - x0) : 0, height: H });
    clip.appendChild(clipRect);
    defs.appendChild(clip);
    svg.appendChild(defs);

    // griglia orizzontale tratteggiata
    for (var v = 0; v <= scale.max; v += scale.step) {
      svg.appendChild(svgEl('line', { x1: x0, x2: x1, y1: ys(v), y2: ys(v), stroke: C_GRID, 'stroke-dasharray': '3 3', fill: 'none' }));
    }

    var pts = DATA.map(function (d, i) { return [xs(i), ys(d.revenue)]; });
    var line = monotonePath(pts);
    var g = svgEl('g', { 'clip-path': 'url(#' + uid + 'c)' });
    g.appendChild(svgEl('path', { d: line + 'L' + x1 + ',' + y1 + 'L' + x0 + ',' + y1 + 'Z', fill: 'url(#' + uid + ')', 'fill-opacity': 0.6, stroke: 'none' }));
    g.appendChild(svgEl('path', { d: line, fill: 'none', stroke: C_PRIMARY, 'stroke-width': 2 }));
    svg.appendChild(g);

    // assi
    var texts = [];
    DATA.forEach(function (d, i) {
      var t = svgEl('text', { x: xs(i), y: y1 + 8, 'text-anchor': 'middle', fill: C_TICK, 'font-size': 11, dy: '0.71em' });
      t.textContent = d.month;
      svg.appendChild(t);
      texts.push(t);
    });
    for (v = 0; v <= scale.max; v += scale.step) {
      var ty = Math.max(ys(v), y0 + 3.25);
      var t2 = svgEl('text', { x: x0 - 8, y: ty, 'text-anchor': 'end', fill: C_TICK, 'font-size': 11, dy: '0.355em' });
      t2.textContent = fmtK(v);
      svg.appendChild(t2);
    }

    // cursore + active dot
    var cursor = svgEl('line', { x1: 0, x2: 0, y1: y0, y2: y1, stroke: 'rgba(254,234,0,0.6)', 'stroke-width': 1, visibility: 'hidden' });
    var dot = svgEl('circle', { r: 5, fill: '#feea00', stroke: '#011624', 'stroke-width': 2, visibility: 'hidden' });
    svg.appendChild(cursor);
    svg.appendChild(dot);
    box.appendChild(svg);

    // l'ultima etichetta X non deve uscire dal bordo (come Recharts)
    var last = texts[texts.length - 1];
    try {
      var half = last.getComputedTextLength() / 2;
      if (xs(DATA.length - 1) + half > W) last.setAttribute('x', W - half);
    } catch (e) {}

    // tooltip
    var tip = document.createElement('div');
    tip.className = 'iml-chart-tip';
    tip.innerHTML = '<p class="iml-chart-tip__label"></p><span class="iml-chart-tip__item"></span>';
    box.appendChild(tip);

    function onMove(ev) {
      var r = svg.getBoundingClientRect();
      var mx = ev.clientX - r.left, my = ev.clientY - r.top;
      if (mx < x0 - 1 || mx > x1 + 1 || my < y0 || my > y1) { onLeave(); return; }
      var i = Math.round((mx - x0) / ((x1 - x0) / (DATA.length - 1)));
      i = Math.max(0, Math.min(DATA.length - 1, i));
      var px = xs(i), py = ys(DATA[i].revenue);
      cursor.setAttribute('x1', px); cursor.setAttribute('x2', px); cursor.setAttribute('visibility', 'visible');
      dot.setAttribute('cx', px); dot.setAttribute('cy', py); dot.setAttribute('visibility', 'visible');
      tip.firstChild.textContent = DATA[i].month;
      tip.lastChild.textContent = TIP_LABEL + ' : ' + CURRENCY + DATA[i].revenue.toLocaleString();
      var tw = tip.offsetWidth, th = tip.offsetHeight;
      var tx = mx + 10 + tw > W ? mx - 10 - tw : mx + 10;
      var tyy = my + 10 + th > H ? Math.max(0, my - 10 - th) : my + 10;
      tip.style.transform = 'translate(' + tx + 'px,' + tyy + 'px)';
      tip.classList.add('is-on');
    }
    function onLeave() {
      cursor.setAttribute('visibility', 'hidden');
      dot.setAttribute('visibility', 'hidden');
      tip.classList.remove('is-on');
    }
    svg.addEventListener('mousemove', onMove);
    svg.addEventListener('mouseleave', onLeave);

    // animazione di disegno (Recharts: 1500ms ease)
    if (!reduceMotion && !box.dataset.animated) {
      box.dataset.animated = '1';
      var start = null, dur = 1500, full = x1 - x0;
      var ease = function (p) { return p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p; };
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        clipRect.setAttribute('width', full * ease(p));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    } else {
      clipRect.setAttribute('width', x1 - x0 + 4);
    }
  }

  function drawBars(box) {
    box.innerHTML = '';
    var W = box.clientWidth, H = box.clientHeight;
    if (!W || !H) return;
    // margin {top:0,right:5,left:-20,bottom:0}, assi nascosti
    var x0 = -20, x1 = W - 5;
    var maxE = Math.max.apply(null, DATA.map(function (d) { return d.emails; }));
    if (!(maxE > 0)) return;
    var scale = niceMax(maxE);
    var band = (x1 - x0) / DATA.length;
    var bw = Math.floor(band * 0.8);
    var svg = svgEl('svg', { width: W, height: H, viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': 'Email inviate per mese' });
    svg.style.display = 'block';
    var animate = !reduceMotion && !box.dataset.animated;
    box.dataset.animated = '1';
    DATA.forEach(function (d, i) {
      var h = d.emails / scale.max * H;
      var x = x0 + i * band + band * 0.1;
      var r = 3;
      var path = svgEl('path', { fill: C_PRIMARY, opacity: 0.6 });
      var setH = function (hh) {
        var y = H - hh, rr = Math.min(r, hh / 2, bw / 2);
        path.setAttribute('d', 'M' + x + ',' + (y + rr) + 'A' + rr + ',' + rr + ',0,0,1,' + (x + rr) + ',' + y +
          'L' + (x + bw - rr) + ',' + y + 'A' + rr + ',' + rr + ',0,0,1,' + (x + bw) + ',' + (y + rr) +
          'L' + (x + bw) + ',' + H + 'L' + x + ',' + H + 'Z');
      };
      setH(animate ? 0 : h);
      svg.appendChild(path);
      if (animate) {
        var start = null;
        var step = function (ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / 400);
          setH(h * (p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    });
    box.appendChild(svg);
  }

  function initCharts(root) {
    var chart = root.querySelector('[data-iml-chart]');
    if (!chart) return;
    DATA = readData(chart);
    CURRENCY = chart.dataset.currency || '€';
    TIP_LABEL = chart.dataset.tooltipLabel || 'Revenue';
    var area = root.querySelector('[data-iml-area]');
    var bars = root.querySelector('[data-iml-bars]');
    if (!area && !bars) return;
    var drawn = false;
    function draw() {
      // il pannello è visibile solo da 1024px in su
      if (area && area.clientWidth) { drawArea(area); drawn = true; }
      if (bars && bars.clientWidth) drawBars(bars);
    }
    // disegna quando la card entra (delay hero 0.6s)
    setTimeout(draw, reduceMotion ? 0 : 600);
    var lastW = window.innerWidth, t;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW && drawn) return;
      lastW = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(draw, 150);
    });
  }

  function init() {
    document.querySelectorAll('.iml').forEach(function (root) {
      if (root.dataset.imlReady) return;
      root.dataset.imlReady = '1';
      if (reduceMotion) {
        root.querySelectorAll('[data-reveal],[data-enter]').forEach(function (el) { el.classList.add('is-in'); });
      } else {
        initEnter(root);
        initReveal(root);
      }
      initSticky(root);
      initNav(root);
      initRotate(root);
      initAccordion(root);
      initCarousel(root);
      initCharts(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-init quando la sezione viene ricaricata
  document.addEventListener('shopify:section:load', function () { init(); });
})();
